import axios from 'axios';

export const BCCRefundService = {
  async postBccRefund(payload, extRefNo) {
    const res = await axios.post(
      `/payments/v1/report/refund/${extRefNo}/`,
      payload
    );

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
